// extracted by mini-css-extract-plugin
module.exports = {"btn-primary":"_button-one_btn-primary__1b2fr","one":"_button-one_one__2rTQ2","two":"_button-one_two__12ytg"};